import request from '@/utils/request'

// 创建与真用户信息
export function createUserInfo(data) {
  return request({
    url: '/yuzhen/user-info/create',
    method: 'post',
    data: data
  })
}

// 更新与真用户信息
export function updateUserInfo(data) {
  return request({
    url: '/yuzhen/user-info/update',
    method: 'put',
    data: data
  })
}

// 删除与真用户信息
export function deleteUserInfo(id) {
  return request({
    url: '/yuzhen/user-info/delete?id=' + id,
    method: 'delete'
  })
}

// 获得与真用户信息
export function getUserInfo(id) {
  return request({
    url: '/yuzhen/user-info/get?id=' + id,
    method: 'get'
  })
}

// 获得与真用户信息
export function logoutAccount(pass) {
  return request({
    url: '/yuzhen/user-info/logout?pass=' + pass,
    method: 'get'
  })
}

// 获得与真用户信息分页
export function getUserInfoPage(query) {
  return request({
    url: '/yuzhen/user-info/page',
    method: 'get',
    params: query
  })
}

// 导出与真用户信息 Excel
export function exportUserInfoExcel(query) {
  return request({
    url: '/yuzhen/user-info/export-excel',
    method: 'get',
    params: query,
    responseType: 'blob'
  })
}
